import { useRef as o, useEffect as u } from "react";
function f(n, t) {
  const r = o(t);
  u(function() {
    t !== r.current && n.attributionControl != null && (r.current != null && n.attributionControl.removeAttribution(r.current), t != null && n.attributionControl.addAttribution(t)), r.current = t;
  }, [
    n,
    t
  ]);
}
export {
  f as useAttribution
};
